import React, { Component } from "react";
import styled from "styled-components";
import { colors } from "../utils/helpers";
import Share from "./Share";

const ContenedorFooter = styled.div`
	max-width: 1220px;
	padding: 2em;
	padding-top: 4em;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	@media (max-width: 500px) {
		flex-direction: column;
	}
`;

const ManchetaCont = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

const DC = styled.svg`
	height: 40px;
	width: 40px;
	cursor: pointer;
`;

const Contacto = styled.div`
	padding: 0;
	margin: 0;
	padding-left: 0.8em;
	font-size: 0.8em;
	height: 40px;
	padding-top: 0.2em;
`;

const Diario = styled.p`
	padding: 0;
	margin: 0;
`;

const Direccion = Diario.extend`
	padding-top: 0.2em;
`;

const ShareCont = styled.div`
	margin-left: auto;
	@media (max-width: 500px) {
		margin-left: 0;
		padding-top: 1em;
		padding-bottom: 1em;
	}
`;

export default class Footer extends Component {
	render() {
		return (
			<ContenedorFooter>
				<ManchetaCont>
					<DC>
						<a
							href="http://www.diariodecadiz.es/semana_santa/cuaresma/"
							alt="Diario de Cádiz"
							target="_blank"
							rel="noopener noreferrer"
						>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 22">
								<path
									d="M10.6 3C9.3 1.7 7.8 1.7 6.3 1.7H1.5V3h.8c.6 0 .6 0 .6 1.1V13c0 1.1 0 1.1-.6 1.1h-.8v1.4h4.4c1.9 0 2.9-.1 3.8-.6 1.8-1.1 2.8-3.3 2.8-6.2-.1-2.5-.7-4.4-1.9-5.7zM9.4 8.5c0 5.2-1.4 5.6-3.1 5.6H6c-.3 0-.3-.2-.3-.8V4c-.1-1 .1-1 .5-1h.5c1.9 0 2.7 1.6 2.7 5.5zm14.8 2.2c-.2 1.8-1.3 5.1-4.6 5.1-3.1 0-5.2-2.7-5.2-6.9 0-1.8.4-7.5 5.6-7.5 1.1 0 2.7.3 3.7 1.1l.1.1.2 4.2h-1.2v-.2c-.3-3.2-1.5-3.8-2.4-3.8-2.5 0-2.8 4.1-2.8 5.8 0 3.6.9 5.5 2.6 5.5 1.4 0 2.5-1.3 2.8-3.4v-.2h1.2v.2z"
									fill={colors.black}
								/>
								<path fill={colors.main} d="M1 20.9v-3.1h23.2v3.1z" />
							</svg>
						</a>
					</DC>
					<Contacto>
						<Diario>
							<strong>Diario de Cádiz</strong>
						</Diario>
						<Direccion>Avenida del Puerto, 2</Direccion>
					</Contacto>
				</ManchetaCont>
				<ShareCont>
					<Share />
				</ShareCont>
			</ContenedorFooter>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Footer.js